import { Link } from 'react-router-dom';
import JsonLd from './JsonLd';

interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbsProps {
  items: Crumb[];
}

const SITE_ORIGIN = 'https://jinghuibt.cn';

export default function Breadcrumbs({ items }: BreadcrumbsProps) {
  const list = [{ label: '首页', to: '/' }, ...items];

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: list.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      item: `${SITE_ORIGIN}${item.to ?? ''}`,
    })),
  };

  return (
    <>
      <JsonLd data={schema} />
      <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-1 text-sm text-foreground-500">
        {list.map((item, index) => {
          const isLast = index === list.length - 1;
          return (
            <span key={`${item.label}-${index}`} className="flex items-center gap-1">
              {item.to && !isLast ? (
                <Link to={item.to} className="cursor-pointer transition-colors hover:text-primary-600">
                  {item.label}
                </Link>
              ) : (
                <span className="text-foreground-800" aria-current="page">{item.label}</span>
              )}
              {!isLast && <i className="ri-arrow-right-s-line text-foreground-300" aria-hidden="true" />}
            </span>
          );
        })}
      </nav>
    </>
  );
}